import { PermissionRequirement } from '@core/auth/permission.model';
import {
  CONFIG_NAV_MODULE_ID,
  POS_RAIL_MESAS_ID,
  POS_RAIL_MODULE_IDS,
  POS_RAIL_TABLERO_ID,
} from '@core/shell/admin-shell-mode.model';
import { COMPANY_SETTINGS_PERMISSIONS } from './company-permissions.config';
import { CUSTOMERS_PERMISSIONS } from './customers-permissions.config';
import { INVENTORY_ITEM_PERMISSIONS } from './inventory-permissions.config';
import { FINANCE_ACCOUNT_PERMISSIONS } from './finance-permissions.config';
import { PURCHASES_ORDER_PERMISSIONS } from './purchases-permissions.config';
import { PAYROLL_EMPLOYEE_PERMISSIONS } from './payroll-permissions.config';
import { REPORTS_INGRESOS_EGRESOS_PERMISSIONS } from './reports-permissions.config';
import {
  DASHBOARD_PERMISSION,
  FINANCE_NAV_MODULE_ID,
  INVENTORY_NAV_MODULE_ID,
  PAYROLL_NAV_MODULE_ID,
  PURCHASES_NAV_MODULE_ID,
  REPORTS_NAV_MODULE_ID,
} from './nav-route-permissions.config';
import { POS_PERMISSIONS } from './pos-permissions.config';
import { SALES_BOARD_PERMISSIONS } from './sales-permissions.config';

/** Permiso ancla legacy por módulo (fallback si el grupo no tiene lectura explícita). */
export const NAV_MODULE_PERMISSION: Readonly<Record<number, PermissionRequirement | null>> = {
  1: DASHBOARD_PERMISSION,
  2: { resource: 'storefront_profile', action: 'index' },
  3: { resource: 'products', action: 'index' },
  4: { resource: 'sales_orders', action: 'index' },
  5: CUSTOMERS_PERMISSIONS.list,
  [INVENTORY_NAV_MODULE_ID]: INVENTORY_ITEM_PERMISSIONS.list,
  [FINANCE_NAV_MODULE_ID]: FINANCE_ACCOUNT_PERMISSIONS.list,
  [PURCHASES_NAV_MODULE_ID]: PURCHASES_ORDER_PERMISSIONS.list,
  [PAYROLL_NAV_MODULE_ID]: PAYROLL_EMPLOYEE_PERMISSIONS.list,
  [REPORTS_NAV_MODULE_ID]: REPORTS_INGRESOS_EGRESOS_PERMISSIONS.show,
  [CONFIG_NAV_MODULE_ID]: COMPANY_SETTINGS_PERMISSIONS.show,
  ...Object.fromEntries(POS_RAIL_MODULE_IDS.map((id) => [id, POS_PERMISSIONS.index])),
  [POS_RAIL_MESAS_ID]: POS_PERMISSIONS.tablesIndex,
  [POS_RAIL_TABLERO_ID]: SALES_BOARD_PERMISSIONS.list,
};

export const TEAM_ADMIN_PERMISSIONS: readonly PermissionRequirement[] = [
  { resource: 'roles', action: 'update' },
  { resource: 'roles', action: 'index' },
  { resource: 'users', action: 'index' },
  { resource: 'users', action: 'update' },
];

export function isConfigurationNavModule(moduleId: number): boolean {
  return moduleId === CONFIG_NAV_MODULE_ID;
}
